import { ServiceBase } from "@app/shared";
import { Features } from "@app/feature-flags";

/** Handles querying the 2.0 API for feature flag status */
export default class FeatureFlagService extends ServiceBase {
  private featureFlagsEndpoint = `${this.apiEndpoint}/feature-flags`;

  /**
   * 
   * @returns A Set of all enabled feature flags
   */
  public async getAllEnabledFeatures(): Promise<Set<Features>> {
    return new Set(await this.makeGet<Features[]>("get-enabled-features", null, this.featureFlagsEndpoint));
  }
}
